<template>
  <div>
    <v-form @submit.prevent="submit" lazy-validation ref="form">
      <v-text-field
        v-model="form.username"
        label="아이디"
        outlined
        :disabled="edit"
        ref="shouldFocused"
        :rules="rules.username"
      ></v-text-field>
      <v-text-field
        v-model="form.password"
        label="비밀번호"
        :type="showPassword ? 'text' : 'password'"
        :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
        @click:append="showPassword = !showPassword"
        :rules="rules.password"
        outlined
      ></v-text-field>
      <v-text-field
        label="비밀번호 확인"
        :type="showPassword ? 'text' : 'password'"
        :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
        @click:append="showPassword = !showPassword"
        :rules="rules.confirmPassword"
        outlined
      ></v-text-field>
      <v-select
        v-model="form.companies"
        label="회사"
        multiple
        outlined
        :items="companyAccesses"
      ></v-select>

      <v-btn type="submit" color="primary">{{ submitText }}</v-btn>
    </v-form>
  </div>
</template>

<script>
import { addUser, getUser, editUser, getCompanies } from '@/api'

export default {
  props: {
    edit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      id: null,
      companies: [],
      showPassword: false,
      form: {
        username: '',
        password: '',
        companies: []
      },
      rules: {
        username: [
          this.required
        ],
        password: [
          this.edit ? () => true : this.required
        ],
        confirmPassword: [
          val => !this.form.password || val === this.form.password || '비밀번호가 다릅니다.'
        ]
      }
    }
  },
  mounted () {
    this.$refs.shouldFocused.focus()
  },
  computed: {
    submitText () {
      return this.edit ? '편집' : '등록'
    },
    companyAccesses () {
      return this.companies.map(company => {
        return {
          value: company.id,
          text: company.name
        }
      })
    }
  },
  async beforeRouteEnter (to, from, next) {
    const id = to.params.id
    const { items: companies } = await getCompanies({}).catch(() => ({ items: [] }))

    try {
      const user = id ? await getUser(id) : null

      next(vm => {
        if (user) {
          vm.id = user.id
          vm.form.username = user.username
          vm.form.companies = user.companies.map(company => company.id)
        }

        vm.companies = companies
      })
    } catch (err) {
      console.error(err.message)
      next()
    }
  },
  methods: {
    required (val) {
      return !!val || '필수 입력 사항입니다.'
    },
    async submit () {
      if (!this.$refs.form.validate()) return
      if (!confirm('이대로 적용 하시겠습니까?')) return
      this.edit ? this.putUser() : this.postUser()
    },
    async postUser () {
      try {
        await addUser(this.form)
        this.$router.go(-1)
      } catch (err) {
        alert(err.message)
      }
    },
    async putUser () {
      try {
        await editUser(this.id, this.form)
        this.$router.go(-1)
      } catch (err) {
        alert(err.message)
      }
    }
  }
}
</script>
